import React from 'react'

import { NoFound } from './common/Placeholder'

export const DataError: React.FC = () => {
  return (
    <div className="flex flex-1 items-center justify-center">
      <NoFound />
    </div>
  )
}

export const RouteError: React.FC = () => {
  return (
    <div className="flex flex-1 items-center justify-center">
      <NoFound />
    </div>
  )
}
